import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect() {
        const rating = this.element.dataset.rating;
        this.element.querySelectorAll('rect')[1].setAttribute('x', rating + '%');
    }
}